module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-展开内容.dcff5.png";